import { Component } from '@verndale/core';
import { debounce } from '../../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      cardContent: this.el.querySelector('.generic-card__content'),
      cardSubheading: this.el.querySelector(
        '.generic-card__optional-subheading'
      )
    };
    this.setDecorationHeight();
  }

  setDecorationHeight() {
    const offset = this.dom.cardSubheading ? 34 : 28;

    this.el.style.setProperty(
      '--decoration-height',
      `${this.dom.cardContent.offsetHeight - offset}px`
    );
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.setDecorationHeight.bind(this), 100)
    );
  }
}

export default Module;
